import { hostBridge } from '@publicala/delfino';
import type { TrackingEventName, TrackingPayload } from '@publicala/delfino';
import { isE2EMockActive } from '../e2eMockGuard';

/**
 * Analytics API for Volpe.
 * Provides methods to notify analytics events to the host via hostBridge.
 */
class AnalyticsAPI {
    /**
     * Track an analytics event via hostBridge.
     * Skipped in E2E standalone mode to prevent errors when hostBridge is not initialized.
     * @param eventName - Name of the tracking event
     * @param payload - Event payload data
     */
    async track(eventName: TrackingEventName, payload: TrackingPayload): Promise<void> {
        if (isE2EMockActive()) {
            return;
        }
        return hostBridge.analytics.track({ eventName, payload });
    }
}

export const analyticsAPI = new AnalyticsAPI();
